var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('SearchBar',{attrs:{"queryString":_vm.queryString,"getParams":_vm.getParams,"getData":_vm.getData}}),_vm._v(" "),_c('Recipes',{attrs:{"recipes":_vm.recipes.matches}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a782678","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Container.vue
// module id = AXQz
// module chunks = 1